import { render } from "./LicenseAbout.vue?vue&type=template&id=3a296b70&scoped=true"
import script from "./LicenseAbout.vue?vue&type=script&lang=js"
export * from "./LicenseAbout.vue?vue&type=script&lang=js"

import "./LicenseAbout.vue?vue&type=style&index=0&id=3a296b70&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a296b70"]])

export default __exports__